<script setup>
import { ref, onMounted, computed } from "vue";
import { useStore } from 'vuex';
import { Empty, message, Modal, Input} from "ant-design-vue";
import {getCreateV2Template} from "../templates/resumeTemplate";
const store = useStore();
const AEmpty = Empty;
const AModal = Modal;
const AInput = Input;
let editTitle = ref(false);
let curModifyResumeItem = ref(null);
let newResumeTitle = ref('');

onMounted(() => {
    window?.$Bus?.on('closeEditTitle', async () => {
        editTitle.value = false;
    });
})


let props = defineProps({
    closeVisibleHandle: {
        type: Function,
        default: () => {}
    },
});

let renderResumeV2List = computed(() => {
    let checkResumeList = store.state.serverResumeV2List || [];
    let processedList = [];
    if (checkResumeList.length > 0) {
        processedList = checkResumeList.map(item => {
            let tempItem = { ...item }; // 创建副本避免直接修改原数据
            try {
                // 包含{ 和 }
                if (item.resumeData && typeof item.resumeData === 'string' && item.resumeData.indexOf('{') > -1 && item.resumeData.indexOf('}') > -1) {
                    tempItem.resumeData = JSON.parse(item.resumeData);
                } else if (!tempItem.resumeData) {
                    tempItem.resumeData = getCreateV2Template();
                }
            } catch (error) {
                console.log('parse error:', error);
                tempItem.resumeData = getCreateV2Template();
            }
            return tempItem;
        })
    } else {
        processedList = [];
    }
    return [store.state.defaultServeResumeData, ...processedList];
})

const isCreateType = (item) => {
    return item.type === "createType";
}

const clickCardFn = (item) => {
    if (isEditing(item)) return;
    if (item.resumeData) {
        store.commit('CHANGE_RESUME_TEMPLATE', item.resumeData);
        store.state.curEditServeResumeId = item.resumeId;
        window.userServerSaveTemplateData = store.state.templateAddCurstyleTypeData = item.resumeData;
        message.success('简历切换成功');
        setTimeout(() => {
            store.state.resetAIinterviewer = true;
            props?.closeVisibleHandle?.();
        }, 500)
    }
}

const editResumeTitle = (item) => {
    // 默认简历不允许修改
    if (!isCreateType(item)) return message.error('默认简历不允许修改标题');
    editTitle.value = true;
    curModifyResumeItem.value = item;
    newResumeTitle.value = item.resumeTitle;
    
}

const deleteResume = (item) => {
    // console.log('deleteResume', item);
    if (item.resumeId) {
         Modal.confirm({
            title: '是否确认删除这份简历?',
            okText: '删除',
            cancelText: '取消',
            onOk() {
                store.commit('DELETE_RESUME_ITEM', item.resumeId);
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
}

const isEditing = (item) => {
    return item.resumeId === store.state.curEditServeResumeId;
}

const handleOk = () => {
    let trimTitle = newResumeTitle.value.replace(/\s+/g, '');
    if (!trimTitle) return message.error('简历标题不能为空');
    store.commit('UPDATE_RESUME', {
        resumeId: curModifyResumeItem.value.resumeId,
        resumeTitle: newResumeTitle.value,
    });
    curModifyResumeItem.value.resumeTitle = newResumeTitle.value;
}

</script>

<template>
  <div class="resumeList-body">
    <section class="resumeList-list" v-if="renderResumeV2List.length > 0" id=“resumeList-list-box”>
        <div class="resume-card" v-for="item in renderResumeV2List" :key="item.id" @click="clickCardFn(item)" :data-id="item.resumeId">
            <div class="resume-card-left">
                <div class="card-left-title">
                    <span class="fas fa-file-word mr-2"></span>
                    <div class="title-text" @click.stop="editResumeTitle(item)">{{item.resumeTitle}}</div>
                     <span :class="['title-tag', { 'create-tag': isCreateType(item) }]">{{ isCreateType(item) ? "新建简历" : "默认简历"}}</span>
                </div>
                <p class="card-left-time">创建于 {{item.resumeCreateTime}}</p>
            </div>
            <div class="resume-card-right" >
                <div class="resume-card-tools" >
                    <!-- <span class="edite-status">编辑中</span> -->
                    <span :class="['edite-icon', isEditing(item) ? 'edite-icon-active' : '']" @click.stop="clickCardFn(item)"><svg t="1758117841696" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2443" width="14" height="14"  fill="currentColor" ><path  d="M474.58679343 587.16868738c-11.45302241 0-22.90604486-4.37057868-31.6472022-13.11173601-17.48231469-17.48231469-17.48231469-45.83841849 0-63.29440437l487.24053555-487.24053552c17.48231469-17.48231469 45.81208967-17.48231469 63.29440431 0 17.48231469 17.48231469 17.48231469 45.83841849 0 63.29440441L506.23399561 574.05695137a44.61676276 44.61676276 0 0 1-31.64720218 13.11173601z" fill="#2c2c2c" p-id="2444" ></path><path  fill="currentColor" d="M904.16728498 1017.19676833h-781.96497912c-62.68884228 0-113.68770304-50.99886074-113.68770305-113.71403181v-781.96497913c0-62.71517108 50.99886074-113.71403182 113.66137425-113.71403185l457.51533479 0.0263288c24.72273117 0 44.75893818 20.03620706 44.75893819 44.7589382s-20.03620706 44.75893818-44.75893819 44.7589382l-457.51533479-0.02632877c-13.2960375 0-24.14349786 10.84746035-24.14349785 24.16982661v781.96497915c0 13.32236631 10.84746035 24.1698266 24.16982665 24.16982664h781.96497912c13.32236631 0 24.1698266-10.84746035 24.16982668-24.16982664V403.42008173c0-24.72273117 20.06253583-44.75893818 44.75893815-44.75893828 24.72273117 0 44.75893818 20.03620706 44.7589382 44.75893828V903.50906532c0 62.68884228-50.99886074 113.68770304-113.68770303 113.68770301z" p-id="2445"></path></svg></span>
                    <span v-if="!isEditing(item) && isCreateType(item)" class="fas fa-trash" @click.stop="deleteResume(item)"></span>
                </div>
                <svg t="1758216028416" v-if="isEditing(item)" class="icon editing-image" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8548" width="50" height="50"><path d="M1024 1024L0 0h512L1024 512V1024z" fill="#E1534E" p-id="8549"></path><path d="M542.968242 265.122909l-75.776 75.238142a62.184727 62.184727 0 0 1-9.184969 7.757575 14.294626 14.294626 0 0 1-15.742707 0.765414 63.612121 63.612121 0 0 1-9.453899-6.433616l-5.026909-3.889131 9.681454-19.631838-4.840727 4.799353-13.508525-13.61196 31.506101-31.299232-11.005415-11.067475-31.506101 31.278546-13.508525-13.549899 31.423354-31.340606-10.612364-10.695111-41.746101 41.373737-14.66699-14.770424 58.771394-58.33697A286.430384 286.430384 0 0 1 380.348768 235.830303a134.961131 134.961131 0 0 1-35.540041 13.301657l-4.613171-23.603718a158.295919 158.295919 0 0 0 23.769212-6.930101l-7.033536-4.778666q-4.75798-3.227152-10.819232-7.219717c-4.137374-2.668606-8.274747-5.41996-12.825859-8.274748L320.708525 190.319192l-10.033131-6.433616-5.399273-3.516768 15.453091-20.376566c0.910222 0.641293 2.937535 2.068687 6.08194 3.992566s6.764606 4.364929 10.819232 7.033535 8.419556 5.523394 13.115475 8.564364 9.18497 5.957818 13.425777 8.688485 7.943758 5.109657 11.108849 7.116283 5.295838 3.351273 6.454303 4.013252l-10.446869 12.288-5.006222 5.771637a182.044444 182.044444 0 0 0 22.010828-11.460526 264.047192 264.047192 0 0 0 22.755556-15.701333q11.791515-8.998788 24.451879-20.686869t27.161858-26.003394l41.373738-41.063434 40.732444 41.001374q2.896162-4.799354 5.316525-9.51596c1.613576-3.144404 3.247838-6.454303 4.944162-9.929697l21.410909 15.411717q-2.316929 5.357899-5.502707 11.832889c-2.068687 4.302869-4.240808 8.378182-6.206061 12.22594l38.001778 38.291394-47.931475 47.579798L471.205495 165.494949c-2.337616 2.296242-4.675232 4.571798-7.074909 6.80598s-4.654545 4.447677-6.847354 6.619798z m-143.380686-159.102707l-4.633859-3.309899c-1.406707-1.05503-3.082343-2.068687-5.006222-3.330586l14.480808-21.721212a29.66497 29.66497 0 0 0 11.398464 0.641293c3.330586-0.744727 7.819636-2.068687 13.425778-3.868444s11.605333-3.951192 18.059637-6.350869 13.032727-5.047596 19.797333-7.902384 13.115475-5.668202 19.031919-8.460929l9.24703 22.755555q-9.288404 4.137374-19.983515 8.088566t-20.48 7.012848q-9.764202 3.144404-17.873454 5.192404a115.287919 115.287919 0 0 1-12.163879 2.627233l16.77705 14.99798q9.081535-2.854788 17.687273-5.606142t15.928889-5.399273l5.978505 21.47297c-6.330182 2.668606-13.487838 5.440646-21.555717 8.274748s-16.259879 5.523394-24.617374 8.047192-16.549495 4.861414-24.534626 6.992161-15.018667 3.76501-21.059232 4.902788l6.20606 4.385616c2.503111 1.737697 5.109657 3.537455 7.819637 5.357899l8.005818 5.357899c2.647919 1.758384 4.861414 3.144404 6.661172 4.137374l-17.583839 18.225131q-2.068687-1.737697-7.343838-5.440646l-11.295031-8.088566-12.060444-8.667798L359.951515 159.288889c-2.068687-1.551515-4.137374-2.958222-6.081939-4.137374l-5.895758-3.599515 14.894546-22.900364a19.921455 19.921455 0 0 0 7.426585 2.668606 28.961616 28.961616 0 0 0 6.206061 0q4.633859-1.117091 15.266909-3.951191t23.955394-6.80598l-9.164283-8.46093a74.203798 74.203798 0 0 0-6.971474-6.081939z m41.808161 132.954505L463.427232 217.212121l-10.508929-10.798545-22.134949 21.86602z m2.234182 81.52695a46.131717 46.131717 0 0 0 4.344242 3.413333 6.930101 6.930101 0 0 0 3.082344 1.179151 4.406303 4.406303 0 0 0 2.813414-0.848161 28.775434 28.775434 0 0 0 3.475394-3.082344l17.790707-17.645899-11.005414-11.088161-24.824243 24.824242z m22.259071-56.826829l22.052202-21.886707-11.005414-11.088161-21.948768 21.886707z m46.545454 2.792728l-10.984727-11.067475L479.397495 277.20404l11.005414 11.088162z m-9.143596-132.954505l-15.659959 15.556525 67.356444 67.832242 15.65996-15.535838zM585.893495 418.557414c-4.137374-2.606545-8.274747-5.295838-12.412121-8.088566s-8.274747-5.564768-12.246627-8.274747l-37.153616 36.843313-15.453091-15.556525 34.236768-33.967838q-20.686869-14.253253-40.546263-29.230546l16.797738-18.949172q10.24 7.985131 20.459313 15.577212t20.914424 15.142788l24.555313-24.389818-30.347636-30.513131 18.369939-18.225131q9.660768-3.827071 23.479596-10.777859t29.27192-15.742707l-14.66699-14.770424 16.549495-16.549495 18.907798 19.052606q7.736889-4.592485 15.06004-9.18497c4.902788-3.061657 9.660768-6.206061 14.315313-9.18497l15.432404 17.873455q-6.950788 4.137374-14.00501 8.709172t-14.211879 8.502303l30.678626 30.906181-16.549494 16.549495-34.75394-35.002181q-15.266909 8.585051-28.775434 15.866828t-24.824243 11.998384l13.301657 13.405091 31.71297-31.464728 14.66699 16.32194-31.030303 30.699313 18.328565 18.473374-17.211475 17.066666-18.328565-18.452687-21.845334 21.679839q5.978505 4.137374 11.770829 8.274747c3.868444 2.730667 7.778263 5.461333 11.770828 8.274748z m80.26505 119.11499l-17.77002-15.577212-20.48 20.355879-17.77002-17.894142 19.528404-19.383596q-20.273131-18.10101-39.760162-36.367515t-39.160242-37.339798l15.65996-16.321939q4.406303 4.137374 8.481616 8.171313c2.70998 2.730667 5.523394 5.440646 8.502303 8.171313l66.19798-65.825616-9.453899-9.536647 14.687676-14.480808 99.586586 100.28994-14.708363 14.604929-12.536243-12.639677-62.82602 62.370909 17.749333 15.577212z m-63.860363-88.291556q10.798545 10.115879 21.617778 20.024889t21.803959 19.838707l11.026101-10.943353L615.248162 436.492929z m28.030707-27.844525l41.373737 41.808162 10.343435-10.343434-41.497859-41.808162z m37.732848-37.422545l-12.184565 12.101818 41.497858 41.787475 12.184566-12.101818z m86.491798 38.787879l-80.285737-80.844283 44.06303-43.773414 80.285738 80.864969z m11.253657-47.04194l-44.39402-44.704323-14.873859 14.770424 44.269899 44.704323zM878.488566 684.735354l-63.550061-64.129293-54.902949 54.509899-19.880081-20.024889 54.902949-54.489212-64.646464-65.122263 85.643636-85.02303 64.646465 65.101575 34.795313-34.54707 19.09398 20.790303-34.009213 33.781656 63.488 63.943111z m-64.418909-102.793051l47.16606-46.835071L816.841697 490.278788l-47.166061 46.835071z m110.467878 16.921859l-43.442424-43.732041L833.949737 601.987879l43.442425 43.73204z" fill="#FFFFFF" p-id="8550"></path></svg>
            </div>
        </div>
        <p class="tips-box">温馨提示: 点击简历标题可修改; 默认简历不可删除/修改标题</p>
    </section>
    <a-empty v-else description="暂无简历" class="mt-8"/>
  </div>
   <a-modal v-model:open="editTitle" okText="确认修改" cancelText="取消" title="修改简历名称" @ok="handleOk">
       <a-input allowClear v-model:value="newResumeTitle" size="large" show-count :maxlength="20" placeholder="请输入简历名称"/>
    </a-modal>
</template>

<style scoped lang="less">
.resumeList-body {
    width: 100%;
    padding: 5px;
    min-height: 100%;
    .resumeList-list {
        .tips-box {
            font-size: 12px;
            color: #999;
        }
        .resume-card {
            overflow: hidden;
            cursor: pointer;
            background: white;
            min-height: 80px;
            border-radius: 8px;
            @apply p-3 mb-4;
            display: flex;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            .resume-card-right {
                width: 100px;
                position: relative;
                // background: red;
                .resume-card-tools {
                    display: flex;
                    height: 100%;
                    justify-content: space-evenly;
                    align-items: center;
                }
                .editing-image {
                    position: absolute;
                    right: -11px;
                    top: -11px;
                }
                .edite-status {
                    padding: 1px 4px;
                    display: inline-block;
                    font-size: 12px;
                    font-weight: 600;
                    color: #e98800;
                    border: 1px solid #e98800;
                    border-radius: 3px;
                }
                span {
                    color: #333;
                    &:hover {
                        color: #1890ff;
                    }
                }
                .edite-icon {
                    cursor: pointer;
                    color: #999;
                    &:hover .icon{
                        color: #1890ff;
                    }
                }
                .edite-icon-active {
                    color: #1890ff;
                }
            }
            .resume-card-left {
                flex: 1;
                position: relative;
                max-width: 340px;
                .card-left-title {
                    max-width: 90%;
                    font-size: 17px;
                    font-weight: 600;
                    color: #333;
                    overflow: hidden;
                    line-height: 30px;
                    position: relative;
                    display: flex;
                    align-items: center;
                    .title-text {
                        max-width: 60%;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right: 5px;
                        cursor: text;
                    }
                    .title-tag {
                        background: #e98800;
                        color: white;
                        padding: 4px;
                        line-height: 12px;
                        border-radius: 3px;
                        font-size: 12px;
                        font-weight: 600;
                    }
                    .create-tag {
                        background: #1890ff;
                    }
                }
                .card-left-time {
                    max-width: 90%;
                    font-size: 13px;
                    font-weight: 600;
                    color: #999;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 30px;
                }
            }
        }
        .resume-card-active {
            outline: 1px solid #1890ff;
        }
    }
}
</style>
